import * as MutationTypes from './mutationTypes';

const setSelectedBlock = (state, selectionData) => {
  state.browserItemsSelections = {
    ...state.browserItemsSelections,
    ...{ [selectionData.containerGuid]: selectionData.selectedGuid }
  };
};

const setBrowserItemsOrder = (state, orderData) => {
  state.browserItemsOrder = {
    ...state.browserItemsOrder,
    ...{ [orderData.containerGuid]: orderData.itemsOrder }
  };
};

const setSelectedLanguage = (state, selectedLanguage) => {
  state.selectedLanguage = selectedLanguage;
};

const setSelectedZoneOfConsume = (state, selectedZoneOfConsume) => {
  state.selectedZoneOfConsume = selectedZoneOfConsume;
};

const setTableGuid = (state, selectedTableGuid) => {
  state.tableGuid = selectedTableGuid;
};

const setPrices = (state, prices) => {
  state.prices = prices;
};

const setUserDefinedData = (state, userDefinedData) => {
  state.userDefinedData = userDefinedData;
};

const setTicketDetailSuccess = (state, payload) => {
  state.ticket = payload;
};

const setSubdomainSuccess = (state, payload) => {
  state.subdomain = payload;
};

const setSaleLocationGuidSuccess = (state, payload) => {
  state.saleLocationGuid = payload;
};

const setStatusSuccess = (state, payload) => {
  state.status = payload;
};

const setCurrencySymbol = (state, currencySymbol) => {
  state.currencySymbol = currencySymbol;
};

const setCurrencyPosition = (state, currencyPosition) => {
  state.currencyPosition = currencyPosition;
};

const setShowFeatures = (state, showFeatures) => {
  state.showFeatures = showFeatures;
};

const setShowIconFeatures = (state, showIconFeatures) => {
  state.showIconFeatures = showIconFeatures;
};

const setShowProductTags = (state, showProductTags) => {
  state.showProductTags = showProductTags;
};

const setShowIconProductTags = (state, showIconProductTags) => {
  state.showIconProductTags = showIconProductTags;
};

const setScrollBrowserSelected = (state, scrollBrowserSelected) => {
  state.scrollBrowserSelected = {
    ...state.scrollBrowserSelected,
    ...{ [scrollBrowserSelected.clauseGuid]: scrollBrowserSelected.sectionGuid }
  };
};

const setClauseGuidWithSectionsGuid = (state, clauseGuidWithSectionsGuid) => {
  state.clauseGuidWithSectionsGuid = {
    ...state.clauseGuidWithSectionsGuid,
    ...clauseGuidWithSectionsGuid,
  };
};

const addShopList = (state, shopItem) => {
  const key =
    shopItem.key ||
    `${shopItem.menuProductGuid}-${shopItem.productUnitPrice}`;

  state.shopList[key] = {
    productGuid: shopItem.productGuid,
    menuProductGuid: shopItem.menuProductGuid,
    productTotalPrice: shopItem.productTotalPrice,
    productUnitPrice: shopItem.productUnitPrice,
    qty: shopItem.qty,
    image: shopItem.image,
    comments: shopItem.comments,
    commercialName: shopItem.commercialName,
    key
  };
  state.shopList = { ...state.shopList };
};

const subtractShopList = (state, key) => {
  const tempShopList = { ...state.shopList };
  delete tempShopList[key];
  state.shopList = tempShopList;
};

const resetShopList = (state) => {
  state.shopList = {};
};

export const mutations = {
  [MutationTypes.SET_SELECTED_BLOCK]: setSelectedBlock,
  [MutationTypes.SET_BROWSER_ITEMS_ORDER]: setBrowserItemsOrder,
  [MutationTypes.SET_SELECTED_LANGUAGE]: setSelectedLanguage,
  [MutationTypes.SET_SELECTED_ZONE_OF_CONSUME]: setSelectedZoneOfConsume,
  [MutationTypes.SET_PRICES]: setPrices,
  [MutationTypes.SET_USER_DEFINED_DATA]: setUserDefinedData,
  [MutationTypes.SET_TICKET_DETAIL_SUCCESS]: setTicketDetailSuccess,
  [MutationTypes.SET_SUBDOMAIN_SUCCESS]: setSubdomainSuccess,
  [MutationTypes.SET_SALE_LOCATION_GUID_SUCCESS]: setSaleLocationGuidSuccess,
  [MutationTypes.SET_STATUS_SUCCESS]: setStatusSuccess,
  [MutationTypes.SET_CURRENCY_SYMBOL]: setCurrencySymbol,
  [MutationTypes.SET_CURRENCY_POSITION]: setCurrencyPosition,
  [MutationTypes.SET_SHOW_FEATURES]: setShowFeatures,
  [MutationTypes.SET_SCROLL_BROWSER_SELECTION]: setScrollBrowserSelected,
  [MutationTypes.SET_CLAUSE_GUID_WITH_SECTIONS_GUID]: setClauseGuidWithSectionsGuid,
  [MutationTypes.SET_SHOW_ICON_FEATURES]: setShowIconFeatures,
  [MutationTypes.SET_SHOW_PRODUCT_TAGS]: setShowProductTags,
  [MutationTypes.SET_SHOW_ICON_PRODUCT_TAGS]: setShowIconProductTags,
  [MutationTypes.ADD_SHOP_LIST]: addShopList,
  [MutationTypes.SUBTRACT_SHOP_LIST]: subtractShopList,
  [MutationTypes.SET_TABLE_GUID]: setTableGuid,
  [MutationTypes.RESET_SHOP_LIST]: resetShopList
};
